export * from './header/header.component';
export * from './info-modal/info-modal.component';



// WEBPACK FOOTER //
// ./src/app-modules/index.js